// extracted by mini-css-extract-plugin
export default {"row":"Vlcj07MAZe0H8on7U5nS","selfie":"D2JFffNB7gK2LJbwYbTQ"};